import { BaseContainerModel } from '../../base-container.model';
import { bl_crm_label_list_hdr_RowClass } from '../../../dbschema';

export class LabelCrmListContainerModel extends BaseContainerModel {
  bl_crm_label_list_hdr: bl_crm_label_list_hdr_RowClass = new bl_crm_label_list_hdr_RowClass();
}
